import { render, staticRenderFns } from "./BoxFilho.vue?vue&type=template&id=41d331f7&"
import script from "./BoxFilho.vue?vue&type=script&lang=js&"
export * from "./BoxFilho.vue?vue&type=script&lang=js&"
import style0 from "./BoxFilho.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports